












import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter, State } from 'vuex-class';

import RiskResources from '@/services/RiskResources';

import Welcome from '@/components/RiskResources/Welcome.vue';
import Loading from '@/components/Global/Loading.vue';
import Alert from '@/components/Global/Alert.vue';

import { cleanString } from '@/utils/Utils';

@Component({
	name: 'RiskResourcesPage',
	components: {
		Loading,
		Alert,
		Welcome,
	},
})
export default class RiskResourcesPage extends Vue {
	public pagePath: string = undefined;
	public rrTemplate: any = () => undefined;
	private classNames: string[] = [];
	public cleanString: (text: any) => any = cleanString;
	@Getter('user', { namespace: 'Auth' }) private user;
	@Getter('pageTemplate', { namespace: 'RiskResources' }) private pageTemplate!: any;
	@State('post_type', { namespace: 'RiskResources' }) private postType!: any;
	@State('claim_reviews', { namespace: 'RiskResources' }) private claimReviews;
	@State('page', { namespace: 'RiskResources' }) private page;
	@State('webinars', { namespace: 'RiskResources' }) private webinars;
	@State('posts', { namespace: 'RiskResources' }) private posts;
	@State('loading', { namespace: 'RiskResources' }) private loading: boolean;
	@State('error', { namespace: 'RiskResources' }) private error: boolean;
	@State('notFound', { namespace: 'RiskResources' }) private notFound: boolean;

	@Watch('pageTemplate')
	private watchPageTemplate() {
		this.pageTemplateLoader();
	}

	private pageTemplateLoader() {
		if (this.postType === 'page') {
			switch (this.pageTemplate) {
				case 'template-sidebar-content-accordions.php':
					this.rrTemplate = () =>
						import(
							/* webpackChunkName: "RRTemplate" */ './Templates/SidebarAndContentAccordions.vue'
						);
					break;

				case 'template-content-accordions.php':
					this.rrTemplate = () =>
						import(
							/* webpackChunkName: "RRTemplate" */ './Templates/ContentAccordions.vue'
						);
					break;

				case 'template-sidebar-content.php':
					this.rrTemplate = () =>
						import(
							/* webpackChunkName: "RRTemplate" */ './Templates/SidebarAndContent.vue'
						);
					break;

				case 'template-2columngrid.php':
					this.rrTemplate = () =>
						import(/* webpackChunkName: "RRTemplate" */ './Templates/2ColumnGrid.vue');
					break;

				case 'template-common-factors.php':
					this.rrTemplate = () =>
						import(
							/* webpackChunkName: "RRTemplate" */ './Templates/CommonFactors.vue'
						);
					break;

				case 'template-risklutions.php':
					this.rrTemplate = () =>
						import(/* webpackChunkName: "RRTemplate" */ './Templates/Risklutions.vue');
					break;
			}
		} else if (this.postType === 'claim_reviews') {
			if (
				this.claimReviews !== undefined &&
				this.claimReviews.length > 0 &&
				this.page !== undefined
			) {
				this.rrTemplate = () =>
					import(
						/* webpackChunkName: "RRTemplate" */ './Templates/ClaimReviewsSingle.vue'
					);
			} else {
				this.rrTemplate = () =>
					import(/* webpackChunkName: "RRTemplate" */ './Templates/ClaimReviewsHome.vue');
			}
		} else if (this.postType === 'webinars') {
			// For On-Demand Webinars
			if (
				this.webinars !== undefined &&
				this.webinars.length > 0 &&
				this.page !== undefined
			) {
				this.rrTemplate = () =>
					import(
						/* webpackChunkName: "RRTemplate" */ './Templates/OnDemandWebinarsSingle.vue'
					);
			} else {
				this.rrTemplate = () =>
					import(
						/* webpackChunkName: "RRTemplate" */ './Templates/OnDemandWebinarsHome.vue'
					);
			}
		}
	}

	private mounted() {
		window.addEventListener('click', event => {
			// ensure we use the link, in case the click has been received by a subelement
			let { target } = event;
			// @ts-ignore
			while (target && target.tagName !== 'A') {
				// @ts-ignore
				target = target.parentNode;
			}

			/**
			 * Get the href and see if it's going to constellationmutual.com
			 * if so, had query string with user_id so marketing can track
			 * users coming between sites.
			 */
			// @ts-ignore
			if ( target.href.indexOf( 'constellationmutual.com' ) !== -1 ) {
				event.preventDefault();
				// @ts-ignore
				const href = target.href + '?user_id=' + this.user.sub;
				window.open( href, '_blank' );
				return;
			}

			// handle only links that do not reference external resources
			// @ts-ignore
			if (target && target.matches("a:not([href*='://'])") && target.matches("a:not([href*='mailto:'])") && target.href) {

				// some sanity checks taken from vue-router:
				// https://github.com/vuejs/vue-router/blob/dev/src/components/link.js#L106
				const { altKey, ctrlKey, metaKey, shiftKey, button, defaultPrevented } = event;
				// don't handle with control keys
				if (metaKey || altKey || ctrlKey || shiftKey) {
					return;
				}
				// don't handle when preventDefault called
				if (defaultPrevented) {
					return;
				}
				// don't handle right clicks
				if (button !== undefined && button !== 0) {
					return;
				}
				// don't handle if `target="_blank"`
				// @ts-ignore
				if (target && target.getAttribute) {
					// @ts-ignore
					const linkTarget = target.getAttribute('target');
					if (/\b_blank\b/i.test(linkTarget)) {
						return;
					}
				}
				// don't handle same page links/anchors
				// @ts-ignore
				const url = new URL(target.href);
				const to = url.pathname;
				if (window.location.pathname !== to && event.preventDefault) {
					event.preventDefault();
					this.$router.push(to);
				}
			}
		});
	}

	private async created() {
		try {
			this.pagePath = this.$route.params.pathMatch;

			this.classNames = [...this.pagePath.split('/')];

			await RiskResources.whichApiToCall(this.pagePath);
		} finally {
			this.pageTemplateLoader();
		}
	}
}
